const formFunctions = require('./form-functions');
const querySpecification = require('./utils/query-specification-functions');
const colorHelpers = require('./utils/colorHelpers');
const components = require('./components');
const actions = require('./actions');
const { confirm } = require('./components/Confirmation');

module.exports = {
  formFunctions,
  querySpecification,
  ...colorHelpers,
  ...components,
  actions,
  confirm,
};
